/**
 * @param {object} statistics - statistics object
 */
export const getCountStatistics = (statistics) => {
  return (
    (statistics &&
      statistics.overall &&
      statistics.overall.origins &&
      Object.entries(statistics.overall.origins).reduce(
        (currentState, originEntries) => {
          const dataSources = originEntries[1].dataSources;
          const dataSourcesPhotos =
            dataSources &&
            Object.entries(dataSources).map((dataSourceEntries) => {
              const categories =
                dataSourceEntries[1]['vinne_annotation'] &&
                dataSourceEntries[1]['vinne_annotation'].categories;
              const dataSourcePhotos =
                categories &&
                Object.values(categories).reduce(
                  (currentState, category) => {
                    const tags = category.tags;
                    const partialPhotos =
                      tags &&
                      Object.values(tags).reduce(
                        (currentState, tag) => {
                          const photos = tag.photos;
                          const annotated = tag.annotated;
                          const verified = tag.verified;

                          const partialUniquePhotos =
                            (photos &&
                              Object.values(photos).reduce(
                                (currentState, photos) => {
                                  return currentState
                                    .concat(photos)
                                    .filter(
                                      (photo, index, photos) =>
                                        photos.indexOf(photo) === index
                                    );
                                },
                                []
                              )) ||
                            [];

                          const partialUniqueAnnotatedPhotos =
                            (annotated &&
                              Object.values(annotated).reduce(
                                (currentState, photos) => {
                                  return currentState
                                    .concat(photos)
                                    .filter(
                                      (photo, index, photos) =>
                                        photos.indexOf(photo) === index
                                    );
                                },
                                []
                              )) ||
                            [];

                          const partialUniqueVerifiedPhotos =
                            (verified &&
                              Object.values(verified).reduce(
                                (currentState, photos) => {
                                  return currentState
                                    .concat(photos)
                                    .filter(
                                      (photo, index, photos) =>
                                        photos.indexOf(photo) === index
                                    );
                                },
                                []
                              )) ||
                            [];

                          currentState.total = currentState.total
                            .concat(partialUniquePhotos)
                            .filter(
                              (photo, index, photos) =>
                                photos.indexOf(photo) === index
                            );

                          currentState.annotated = currentState.annotated
                            .concat(partialUniqueAnnotatedPhotos)
                            .filter(
                              (photo, index, photos) =>
                                photos.indexOf(photo) === index
                            );

                          currentState.verified = currentState.verified
                            .concat(partialUniqueVerifiedPhotos)
                            .filter(
                              (photo, index, photos) =>
                                photos.indexOf(photo) === index
                            );

                          return currentState;
                        },
                        { total: [], annotated: [], verified: [] }
                      );
                    if (partialPhotos) {
                      currentState.total = currentState.total
                        .concat(partialPhotos.total)
                        .filter(
                          (photo, index, photos) =>
                            photos.indexOf(photo) === index
                        );
                      currentState.annotated = currentState.annotated
                        .concat(partialPhotos.annotated)
                        .filter(
                          (photo, index, photos) =>
                            photos.indexOf(photo) === index
                        );
                      currentState.verified = currentState.verified
                        .concat(partialPhotos.verified)
                        .filter(
                          (photo, index, photos) =>
                            photos.indexOf(photo) === index
                        );
                    }
                    return currentState;
                  },
                  { total: [], annotated: [], verified: [] }
                );
              const dataSource = { id: dataSourceEntries[0] };
              if (dataSourcePhotos) {
                dataSource.total = dataSourcePhotos.total;
                dataSource.annotated = dataSourcePhotos.annotated;
                dataSource.verified = dataSourcePhotos.verified;
              }
              return dataSource;
            });

          if (dataSourcesPhotos && dataSourcesPhotos.length > 0) {
            dataSourcesPhotos.forEach((dataSourcePhotos) => {
              if (!currentState[dataSourcePhotos.id]) {
                currentState[dataSourcePhotos.id] = {
                  total: [],
                  annotated: [],
                  verified: [],
                };
              }
              currentState[dataSourcePhotos.id].total = currentState[
                dataSourcePhotos.id
              ].total
                .concat(dataSourcePhotos.total)
                .filter(
                  (photo, index, photos) => photos.indexOf(photo) === index
                );
              currentState[dataSourcePhotos.id].annotated = currentState[
                dataSourcePhotos.id
              ].annotated
                .concat(dataSourcePhotos.annotated)
                .filter(
                  (photo, index, photos) => photos.indexOf(photo) === index
                );
              currentState[dataSourcePhotos.id].verified = currentState[
                dataSourcePhotos.id
              ].verified
                .concat(dataSourcePhotos.verified)
                .filter(
                  (photo, index, photos) => photos.indexOf(photo) === index
                );
            });
          }
          return currentState;
        },
        {}
      )) ||
    {}
  );
};
